import axios from 'axios';

export const loginUser = (email, password) => async (dispatch) => {
  try {
    // Dispatch a LOGIN_REQUEST action if needed
    dispatch({ type: 'LOGIN_REQUEST' });

    // Make the POST request to the API
    const response = await axios.post('https://cardealer-backend-shac.onrender.com/api/auth/login', { email, password });

    // Dispatch a LOGIN_SUCCESS action with the response data
    dispatch({
      type: 'LOGIN_SUCCESS',
      payload: response.data, // response.data should contain user info and possibly a token
    });

    // Optionally, save the token to local storage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
  } catch (error) {
    // Check if error.response is defined
    const errorMessage =
      error.response && error.response.data.message
        ? error.response.data.message // Use the message from the server if available
        : error.message; // Fallback to the generic error message

    // Dispatch a LOGIN_FAIL action with the error message
    dispatch({
      type: 'LOGIN_FAIL',
      payload: errorMessage,
    });
  }
};
